import api from './../api';
import {decrypt, encrypt, patientResponseValid, setPatientEncrypted} from '../../pages/private/patients/helper'

export default {
  namespaced: true,

  state: {
    item: {},
  },
  getters: {},
  actions: {
    list(store, params) {
      return new Promise((resolve, reject) => {
        api.post('patients/list', params).then(response => {
          const {data} = response
          let loggedUser = store.rootGetters['account/userStore'].getLoggedUser();
          data.items = data.items.map(patient => decrypt(store, loggedUser,patient))
          resolve(data);
        }).catch(error => {
          reject(error.response);
        });
      });
    },
    get(store, id) {
      return new Promise((resolve, reject) => {
        api.get('patients/' + id).then(response => {
          let loggedUser = store.rootGetters['account/userStore'].getLoggedUser();
          store.commit('setItem', decrypt(store, loggedUser,response.data));
          resolve();
        }).catch(error => {
          reject(error.response);
        });
      });
    },
    remove(store, id) {
      return new Promise((resolve, reject) => {
        api.delete('patients/' + id).then(() => {
          store.dispatch('alert/success', 'Patient was deleted', {root: true});
          resolve();
        }).catch(error => {
          store.dispatch('alert/warning', 'Patient was not deleted', {root: true});
          reject(error.response);
        });
      });
    },
    create(store, patient) {
      return new Promise((resolve, reject) => {
        let loggedUser = store.rootGetters['account/userStore'].getLoggedUser();
        let patientCopy = encrypt(store, loggedUser,JSON.parse(JSON.stringify(patient)));
        api.post('patients',{'patient':patientCopy,'bckp':patient} ).then(response => {
          if (patientResponseValid(response)) {
            store.commit('setItem',  decrypt(store, loggedUser,response.data));
            store.dispatch('alert/success', 'Patient was created', {root: true});
            resolve(response.data);
          } else {
            store.dispatch('alert/error', 'Patient NOT created', {root: true});
            reject(response);
          }
        }).catch(error => {
          store.dispatch('alert/warning', error.response.data.status, {root: true});
          reject(error.response.data);
        });
      });
    },
    notify(store, params) {
      return new Promise((resolve, reject) => {
        api.post('patients/notify/' + params.id, params).then(response => {
          store.dispatch('alert/success', 'Patient was notified', {root: true});
          resolve(response.data);
        }).catch(error => {
          store.dispatch('alert/warning', error.response.data.status, {root: true});
          reject(error.response.data);
        });
      });
    },
    update(store, patient) {
      return new Promise((resolve, reject) => {
        let loggedUser = store.rootGetters['account/userStore'].getLoggedUser();
        let patientCopy = encrypt(store, loggedUser,JSON.parse(JSON.stringify(patient)));
        api.put('patients/' + patient.id, {'patient':patientCopy,'bckp':patient})
          .then(response => {
            if (patientResponseValid(response)) {
              store.commit('setItem',  decrypt(store, loggedUser,response.data));
              store.dispatch('alert/success', 'Patient was updated', {root: true});
              resolve(response.data);
            } else {
              store.dispatch('alert/error', 'Patient NOT updated', {root: true});
              reject(response);
            }
          }).catch(error => {
          store.dispatch('alert/warning', error.response.data.status);
          reject(error.response.data);
        });
      });
    },
  },
  mutations: {
    setItem(state, data) {
      state.item = data;
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/patients.js